import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { useLocation } from 'react-router-dom';
import { useSearchParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import axios from "axios"

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
// Autocomplete form in the ConfirmDialog
// import { AutoComplete } from "primereact/autocomplete";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { PickList } from 'primereact/picklist';
import DeletionDialog from '../../components/DeletionDialog';


// // Temp imports for the example of the form
// import { InputTextarea } from 'primereact/inputtextarea';
// import { Dropdown } from 'primereact/dropdown';
// import { Checkbox } from 'primereact/checkbox';
// import { FileUpload } from 'primereact/fileupload';

// // End of Temp imports for the example of the form


// function renderJsonToHtml(jsonObject) {
//     return (
//       <ul>
//         {Object.keys(jsonObject).map((key) => (
//           <li key={key}>
//             <strong>{key}:</strong>
//             {typeof jsonObject[key] === 'object'
//               ? renderJsonToHtml(jsonObject[key])
//               : jsonObject[key]}
//           </li>
//         ))}
//       </ul>
//     );
//   }

export const SampleDetails = (props) => {

    const location = useLocation();
    const [sampleId, setSampleId] = useState(null);
    const [data, setData] = useState({ id: 0, name: "Loading", ownerId: "Loading", createdAt: "Loading", updatedAt: "Loading" });
    const [error, setError] = useState(null); // eslint-disable-line no-unused-vars
    const [loading, setLoading] = useState(false)   // eslint-disable-line no-unused-vars
    const [deleteVisible, setDeleteVisible] = useState(false);

    const [files, setFiles] = useState([]);
    const [sampleAttributes, setSampleAttributes] = useState([]);
    const [sampleGroups, setSampleGroups] = useState([]);

    const [refreshState, setRefreshState] = useState(true);
    let refresh = true;

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars


    // if (searchParams.has('sampleid')) {
    //     console.log("searchParams.has('sampleid')",searchParams.has('sampleid'))
    //     console.log("searchParams.get('sampleid')",searchParams.get('sampleid'))
    // }

    // searchParams.forEach((value, key) => {
    //     console.log(key, value);
    // });

    // console.log("sampleId",sampleId)

    // PickList
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

    useEffect(() => {
        // Get the Files for the PickList
        const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const getData = async () => {
        try {
            const response = await axios.get(
            `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/file?userId=${getDataUserId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getDataUserToken}`,
                }
            }
            );

            setSource(response.data);
            setError(null);

        } catch (err) {
            setError(err.message);
            setSource(null);
        } finally {
            setLoading(false);
        }
        };
        getData();

    }, []);

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                {/* <img className="w-4rem shadow-2 flex-shrink-0 border-round" src={`https://primefaces.org/cdn/primereact/images/product/${item.image}`} alt={item.name} /> */}
                <div className="flex-1 flex flex-column gap-2">
                    <span className="font-bold">{item.name}</span>
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-file text-sm"></i>
                        <span>{item.category}</span>
                    </div>
                </div>
                {/* <span className="font-bold text-900">${item.price}</span> */}
            </div>
        );
    };


    const onChange = (event) => {
        setSource(event.source);
        setTarget(event.target);
    };

    const addFiles = () => {
        // const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
        // const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        Promise.all(target.map((file, fileArr) => {
            
            const formData = new FormData();
            formData.append('fileId'    , file.id);

            try {
                fetch(
                    `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample/${sampleId}`,
                    {
                        method: 'PATCH',
                        headers: {
                            Authorization: `Bearer ${getDataUserToken}`,
                        },
                        body: formData,
                    }
                )
                    .then(res => res.json())
                setError(null);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
                setRefreshState(true);
                refresh = true;
            }

            return null;
        }))
            .then(files => {
                toast.current.show({
                    severity:'success',
                    summary: 'Success', 
                    content: () => (
                        <div className="flex flex-column align-items-left" style={{ flex: '1' }}>
                            <div className="flex flex-column align-items-center gap-2">
                                <div className="font-bold text-900">Added {files.length} file{files.length > 1 ? 's' : ''} to the dataset.</div>
                                <div className="font-bold text-900">Dataset has been saved.</div>
                            </div>
                        </div>
                    ), 
                    life: 10000})
                }
            ) 
        setTarget([]);

    };

    // End of PickList

    // // Temp for the example of the form
    // const [country1, setCountry1] = useState(null);
    // const [check1, setCheck1] = useState(false);
    // const countries = [
    //     { name: 'Australia', code: 'AU' },
    //     { name: 'Brazil', code: 'BR' },
    //     { name: 'China', code: 'CN' },
    //     { name: 'Egypt', code: 'EG' },
    //     { name: 'France', code: 'FR' },
    //     { name: 'Germany', code: 'DE' },
    //     { name: 'India', code: 'IN' },
    //     { name: 'Japan', code: 'JP' },
    //     { name: 'Spain', code: 'ES' },
    //     { name: 'United States', code: 'US' }
    // ];

    // // Temp for the example of the form

    // useEffect(() => {
    //     if (location.state){
    //         setName(location.state.name);
    //     }
    // }, [location.state]);


    useEffect(() => {
        if (searchParams.has('sampleid')) {
            setSampleId(searchParams.get('sampleid'));
        } else if (location.state && location.state.id !== ''){
            setSampleId(location.state.id);
        } else {
            setSampleId(null);  
        }
    }, [searchParams, location.state]);

    useEffect(() => {
        document.title = `Data -> Sample Details | Palmona Pathogenomics`
    }, []);

    // Toast and ConfirmDialog
    const toast = useRef(null);

    // const accept = () => {
    //     toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    // };

    // const reject = () => {
    //     toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    // };




    const show = () => {
        toast.current.show({ severity: 'success', summary: 'Adding Sample Attribute', detail: `${formik.values.name}: ${formik.values.value}`});
    };

// Formik
    const formik = useFormik({
        initialValues: {
            name: '',
            value: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.name) {
                errors.value = 'Name - Name is required.';
            }

            if (!data.value) {
                errors.value = 'Value - Value is required.';
            }

            return errors;
        },
        onSubmit: (data) => {
            data && show(data);

            postOneAttribute(data.name, data.value);
            // formik.setSubmitting(false);
            formik.resetForm();
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> : <small className="p-error">&nbsp;</small>;
    };    


    const postOneAttribute = async (name, value) => {

        const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
        const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const formData = new FormData();
        formData.append('ownerId'  , getDataUserId);
        formData.append('sampleId' , sampleId);
        formData.append('groupId'  , groupIds);
        formData.append('name'     , name);
        formData.append('value'    , value);

        try {
          await axios.post(
            `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample_attribute`, formData,
            {
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getDataUserToken}`,
              }
            }
          );

            // const data = response.data;
            // const status = response.status;
          // if (data === ) {
            //   setData(response.data);
              setError(null);
          // }

          setRefreshState(true);
          refresh = true;
        } catch (err) {
          setError(err.message);
        //   setData(null);
        } finally {
            setLoading(false);
            refresh = true;
        }
      };

    useEffect(() => {

        if (refresh || refreshState) {
            setRefreshState(false);
            refresh = false;            // eslint-disable-line react-hooks/exhaustive-deps
            
            let sampleIdLoc = null;

            if (sampleId) {

                sampleIdLoc =sampleId;

            } else if (searchParams.has('sampleid')){

                sampleIdLoc = searchParams.get('sampleid');

            } else if (location.state) {

                sampleIdLoc = location.state.id;

            } else {
                sampleIdLoc = null;
                setData( { id: 0, name: "Error", ownerId: "Error", createdAt: "Error", updatedAt: "Error" });
            }

            const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
            const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

            const getData = async () => {
                
                try {
                    const response = await axios.get(
                    // `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample/${sampleIdLoc}?userId=${getDataUserId}`,
                    `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample/${sampleIdLoc}/datasets?userId=${getDataUserId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${getDataUserToken}`,
                        }
                    });

                    if (response.status === 200) {
                        // const data = response.data;
                        setFiles(response.data.files);
                        setSampleAttributes(response.data.sampleattributes);
                        setSampleGroups(response.data.samplegroups);

                        // console.log("response.data",response.data)

                        // if (data.length === 0)  {
                            setData(response.data);
                        // }

                        setError(null);
                    } else {
                        setError("Error: " + response.status);

                        // console.log("response.status",response.status);

                        // if (data.length === 0)  {
                            setData( { id: 0, name: "Error", ownerId: "Error", createdAt: "Error", updatedAt: "Error" });
                        // }
                        setFiles([]);
                        setSampleAttributes([]);
                        setSampleGroups([]);
                        

                        // console.log("data.id: " + data.id);
                    }

                } catch (err) {
                    setError(err.message);
                    // setData(null);
                    setData( { id: 0, name: "Error", ownerId: "Error", createdAt: "Error", updatedAt: "Error" });
                } finally {
                    setLoading(false);
                }
            };

            if (sampleIdLoc) {
                getData();
            }
            // getData();

        }
    }, [sampleId, refresh, refreshState]);

    // const showTemplate = () => {
    //     confirmDialog({
    //         group: 'templating',
    //         header: 'Add Attribute',
    //         message: (
    //             <div className="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
    //                 <i className="pi pi-exclamation-circle text-6xl text-primary-500"></i>
    //                 <span>Please enter an Attribute Name and Value to add to the Sample.</span>
    //                 {/* <div className="card flex justify-content-center"> */}
    //                 <div>
    //                   {/* <AutoComplete value={value} suggestions={items} completeMethod={search} onChange={(e) => setValue(e.value)} /> */}

    //                   <div className="flex flex-column gap-2">
    //                   <label htmlFor="attributename">Name</label>
    //                     <InputText id="attributename" className="flex-auto mr-3" aria-describedby="attributename-help" />
    //                     </div>

    //                     <div className="flex flex-column gap-2">
    //                     <label htmlFor="attributevalue">Value</label>
    //                     <InputText id="attributevalue" className="flex-auto mr-3" aria-describedby="attributevalue-help" />
    //                     {/* <Button label="Update" /> */}
    //                 </div>




    //               </div>
    //             </div>
    //         ),
    //         accept,
    //         reject
    //     });
    // };


    const renderFileFooter = () => {
        // if (data.datasets && data.datasets.length > 0) {
        //     return (
        //         <div className="flex justify-content-end" tooltip='Samples which have been attached to one or more Dataset can not be modified.'>
        //             <p>Samples which are part of one or more Dataset can not be modified.</p>
        //         </div>
        //     );

        // } else {
        //     return (
        //         <div className="flex justify-content-end">
        //             <Button onClick={() => removeFiles()} label="Remove Selected Files from Sample" className="w-auto mt-3" tooltip='Remove Files from this sample.'/>
        //         </div>
        //     );

        // }

        if (data.isDeleted) {
            return (
                null
            ); 
        } else {
            return (
                <Button onClick={() => removeFiles()} label="Remove Selected Files from Sample" className="w-auto mt-3" tooltip='Remove Files from this sample.'/> 
            );
        }

        // return (
        //     <div className="flex justify-content-end">
        //         <Button onClick={() => removeFiles()} label="Remove Selected Files from Sample" className="w-auto mt-3" tooltip='Remove Files from this sample.'/>
        //     </div>
        // );
    };

    const fileFooter = renderFileFooter();

    const [selectedFiles, setSelectedFiles] = useState(null);
    const [rowClick, setRowClick] = useState(true);

    const removeFiles = () => {
        // const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
        // const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        Promise.all(selectedFiles.map((file) => {

            const formData = new FormData();
            formData.append('fileId'    , file.id);

            try {
                fetch(
                    `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample/${sampleId}/file/${file.id}`,
                    {
                        method: 'POST',
                        headers: {
                            Authorization: `Bearer ${getDataUserToken}`,
                        },
                        body: formData
                    }
                )
                    .then(res => res.json())
                setError(null);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
                setRefreshState(true);
                refresh = true;
            }

            return null;
        }))
            .then(files => {
                toast.current.show({severity:'success', summary: 'Success', detail:`Removed ${files.length} file${files.length > 1 ? 's' : ''} from the dataset.`, life: 10000});
                setError(null);
                setLoading(false);
                setRefreshState(true);
                refresh = true;
            })
        setSelectedFiles([]);

    };

    const deleteSample = async (fileId) => {

        try {

          const method = 'PUT';

          const body = new FormData();
          body.append("isDeleted", true);

          const headers = {
            'Authorization': `Bearer ${getDataUserToken}`,
          }

          fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/sample/${sampleId}`,
          {
            method,
            headers,
            body
          })
                .then(res => {
                    console.log('res', res);
                    if (res.ok) {
                        navigate("/datasets/manage_sample/sample");
                    }
                })
        }
        catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }    

    const unDeleteSample = async (fileId) => {

        try {

          const method = 'PUT';

          const body = new FormData();
          body.append("isDeleted", false);

          const headers = {
            'Authorization': `Bearer ${getDataUserToken}`,
          }

          fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/sample/${sampleId}`,
          {
            method,
            headers,
            body
          })
                .then(res => {
                    console.log('res', res);
                    if (res.ok) {
                        window.location.reload();
                    }
                })
        }
        catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }    

    const nameBodyTemplate = (file) => {

        const notDeletedClass = 'pi pi-exclamation-triangle text-danger';
        const deletedClass = 'pi pi-check-circle text-success';
        const fileIsDeleted = Boolean(file.isDeleted);

        return (
            <div>
                <i className={ !fileIsDeleted ? deletedClass : notDeletedClass} />
                <Link to={`/datasets/files/filedetails/${file.id}`} className="ml-2">{file.name}</Link>
            </div>
        );
    };

    const isAnyDeletedFiles = () => {
        let isDeleted = false;
        files.forEach(file => {
            if (file.isDeleted) {
                isDeleted = true;
            }
        });
        return isDeleted;
    }

    const [selectedAttributes, setSelectedAttributes] = useState(null);

    const deleteAttributes = () => {
        // const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
        // const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        selectedAttributes.map((attribute) => {

            console.log("attribute.id",attribute.id)
            
            const formData = new FormData();
            formData.append('attributeId'    , attribute.id);

            try {
                axios.delete(
                    `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample_attribute/${attribute.id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${getDataUserToken}`,
                        }
                    }
                );
                setError(null);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
                setRefreshState(true);
                refresh = true;
            }

            return null;
        });
        setSelectedAttributes([]);

    };

    const sampleIsDeleted = data.isDeleted ? 'Deleted' : 'Not Deleted';

    return (
 <>
      <div className="surface-card p-4 shadow-2 border-round">
        <Toast ref={toast} position='center'/>
        <ConfirmDialog group="templating" />
      <div className="font-medium text-3xl text-900 mb-3">Sample Details</div>

      { isAnyDeletedFiles() ?
         <div className="flex justify-content text-danger" tooltip='Files which have been deleted can not be removed from the Sample.'> This sample containes deleted files. </div>
        :
        null   
        }

      <ul className="list-none p-0 m-0">
        <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div className="text-500 w-6 md:w-2 font-medium">ID</div>
            <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.id}</div>
        </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Name</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.name}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Created By</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.ownerId}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Ceated At</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.createdAt}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Last Updated</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.updatedAt}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Deleted</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{sampleIsDeleted}</div>
          </li>

          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Files</div>
              { isAnyDeletedFiles() ?
                <div className="flex justify-content text-danger" tooltip='Files in RED have been deleted'> Files marked with <i className='pi pi-exclamation-triangle text-danger mr-2 ml-2' /> have been deleted. </div>
                :
                null   
                }
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              </div>
              <div className="card">

                

                <DataTable 
                    value={files} 
                    emptyMessage="Sample currently has no Files." 
                    tableStyle={{ minWidth: '50rem' }}
                    footer={ fileFooter }
                    selectionMode={rowClick ? null : 'checkbox'} selection={selectedFiles} onSelectionChange={(e) => setSelectedFiles(e.value)} dataKey="id" 
                >
                    { data.isDeleted ? null : <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} ></Column> }
                    <Column field="name" header="File Name" body={nameBodyTemplate}></Column>
                    <Column field="collection" header="Collection"></Column>
                    <Column field="createdAt" header="Creation Date"></Column>
                </DataTable>

                { data.isDeleted ? null :
                    <>
                    <div className="card">
                        <PickList dataKey="id" source={source} target={target} onChange={onChange} itemTemplate={itemTemplate} filter filterBy="name" breakpoint="1280px"
                            sourceHeader="Available" targetHeader="Selected" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
                            sourceFilterPlaceholder="Search by name" targetFilterPlaceholder="Search by name" />
                    </div>
                    <Button onClick={() => addFiles()} label="Add Selected Files to Sample" className="w-auto m-3" tooltip='Add the files from "Selected" to the sample'/>
                    </>
                }
                </div> 
            
          </li>

          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Sample Attributes</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              </div>
              <div className="card">
                <DataTable 
                    value={sampleAttributes} 
                    emptyMessage="Sample currently has no Attributes." 
                    tableStyle={{ minWidth: '50rem' }}
                    selectionMode={rowClick ? null : 'checkbox'} selection={selectedAttributes} onSelectionChange={(e) => setSelectedAttributes(e.value)} dataKey="id" 
                >
                    { data.isDeleted ? null : <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} ></Column> }
                    <Column field="name" header="Attribute Name"></Column>
                    <Column field="value" header="Attribute Value"></Column>
                </DataTable>
                { data.isDeleted ? null :
                    <Button onClick={() => deleteAttributes()} label="Delete Selected Attributes" className="w-auto m-3" tooltip='Delete the selected Attributes.'/>
                }

                { data.isDeleted ? null :
                    <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
                        {/* <div className="grid"> */}
                        <div>
                            <div className="col-12 lg:col-2">
                                <div className="text-900 font-medium text-xl mb-3">Add Attribute</div>
                                <p className="m-0 p-0 text-600 line-height-3 mr-3">Attributes provide additional information realted to the Sample. Please add the attributes required to execute the required Workflow Definition.</p>
                            </div>

                            <form onSubmit={formik.handleSubmit} className="flex flex-column gap-2">
                                <div className="col-12 lg:col-10">
                                    <div className="grid formgrid p-fluid">
                                        <div className="field mb-4 col-6">
                                            <label htmlFor="input_name">Attribute Name</label>
                                            <InputText
                                                id="name"
                                                name="name"
                                                value={formik.values.name}
                                                onChange={(e) => {
                                                    formik.setFieldValue('name', e.target.value);
                                                }}
                                                className={classNames({ 'p-invalid': isFormFieldInvalid('name') })}
                                            />
                                        </div>
                                        <div className="field mb-4 col-6">
                                            <label htmlFor="input_value">Value</label>
                                            <InputText
                                                id="value"
                                                name="value"
                                                value={formik.values.value}
                                                onChange={(e) => {
                                                    formik.setFieldValue('value', e.target.value);
                                                }}
                                                className={classNames({ 'p-invalid': isFormFieldInvalid('value') })}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {getFormErrorMessage('value')}
                                            {getFormErrorMessage('name')}
                                            <Button type="submit" label="Create Attribute" />
                                        </div>
                                    </div>
                                </div> 
                            </form>
                        </div> 
                    </div>
                }
            </div> 
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Sample Groups</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              </div>
              <div className="card">
                <DataTable value={sampleGroups} emptyMessage="Sample currently has no Attributes." tableStyle={{ minWidth: '50rem' }}>
                    <Column field="id" header="ID"></Column>
                    <Column field="groupId" header="Group ID"></Column>
                </DataTable>
                {/* <Button onClick={() => showTemplate()} icon="pi pi-check" label="Confirm"></Button> */}
                {/* <AutoComplete value={value} suggestions={items} completeMethod={search} onChange={(e) => setValue(e.value)} />
                <Button label="Add Group" onClick={() => setAddGroup(true)} /> */}
            </div> 
            
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Sample Datasets</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              </div>
              <div className="card">
                <DataTable 
                    value={data.datasets} 
                    emptyMessage="Sample currently is not assigned to any Datasets." 
                    tableStyle={{ minWidth: '50rem' }}
                >
                    <Column field="name" header="Name"></Column>
                    <Column field="createdAt" header="Created Date"></Column>
                    <Column field="createdByUsername" header="Created By"></Column>
                    <Column field="lastAggregation" header="Last Aggregated"></Column>
                </DataTable>
            </div> 
            
          </li>
      </ul>
  </div>
  <DeletionDialog visible={deleteVisible} setVisible={setDeleteVisible} deleteCallback={() => deleteSample(data.id)} type='sample' name={data.name}/>

  { data.isDeleted ? 
    <div className="flex justify-end mt-5">
      <Button label="Undelete Sample" onClick={() => unDeleteSample(data.id)} disabled={!data.isDeleted} />
    </div> 
  :
    <div className="flex justify-end mt-5">
        <Button label="Delete Sample" onClick={() => setDeleteVisible(true)} disabled={data.isDeleted} />
    </div>
    }


{/* <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
    <div className="grid">
        <div className="col-12 lg:col-2">
            <div className="text-900 font-medium text-xl mb-3">Profile</div>
            <p className="m-0 p-0 text-600 line-height-3 mr-3">Odio euismod lacinia at quis risus sed vulputate odio.</p>
        </div>
        <div className="col-12 lg:col-10">
            <div className="grid formgrid p-fluid">
                <div className="field mb-4 col-12">
                    <label htmlFor="nickname1" className="font-medium text-900">Nickname</label>
                    <InputText id="nickname1" type="text" />
                </div>
                <div className="field mb-4 col-12">
                    <label htmlFor="avatar1" className="font-medium text-900">Avatar</label>
                    <div className="flex align-items-center">
                        <img src="/demo/images/blocks/avatars/circle/avatar-f-4.png" alt="avatar-f-4" className="mr-4" />
                        <FileUpload id="avatar1" mode="basic" name="avatar" url="./upload.php" accept="image/*" maxFileSize={1000000} chooseOptions={{ className: 'p-button-plain p-button-outlined' }} chooseLabel="Upload Image" />
                    </div>
                </div>
                <div className="field mb-4 col-12">
                    <label htmlFor="bio1" className="font-medium text-900">Bio</label>
                    <InputTextarea id="bio1" type="text" rows={5} autoResize />
                </div>
                <div className="field mb-4 col-12 md:col-6">
                    <label htmlFor="email1" className="font-medium text-900">Email</label>
                    <InputText id="email1" type="text" />
                </div>
                <div className="field mb-4 col-12 md:col-6">
                    <label htmlFor="country1" className="font-medium text-900">Country</label>
                    <Dropdown inputId="country1" options={countries} value={country1} onChange={(e) => setCountry1(e.value) } optionLabel="name" filter filterBy="name" showClear placeholder="Select a Country" itemTemplate={(country) => <div className="flex align-items-center">
                        <img src="/demo/images/blocks/flag/flag_placeholder.png" className={`mr-2 flag flag-${country.code.toLowerCase()}`} style={{ width: '18px' }} alt={country.name} />
                        <div>{country.name}</div>
                    </div>} />
                </div>
                <div className="field mb-4 col-12 md:col-6">
                    <label htmlFor="city1" className="font-medium text-900">City</label>
                    <InputText id="city1" type="text" />
                </div>
                <div className="field mb-4 col-12 md:col-6">
                    <label htmlFor="state1" className="font-medium text-900">State</label>
                    <InputText id="state1" type="text" />
                </div>
                <div className="field mb-4 col-12">
                    <label htmlFor="website1" className="font-medium text-900">Website</label>
                    <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">www</span>
                        <InputText id="website1" type="text" />
                    </div>
                </div>
                <div className="field mb-4 col-12">
                    <label htmlFor="privacy1" className="font-medium text-900">Privacy</label>
                    <div className="flex align-items-center">
                        <Checkbox inputId="privacy1" checked={check1} onChange={(e) => setCheck1(e.checked)} />
                        <span className="ml-2 text-900">Share my data with contacts</span>
                    </div>
                </div>
                <div className="col-12">
                    <Button label="Save Changes" className="w-auto mt-3" />
                </div>
            </div>
        </div>
    </div>
</div> */}

</>
    )

}
export default SampleDetails;